import { useFormikContext } from 'formik';
import React from 'react';
import { searchAtcCodes, searchMedicinalProducts, searchPoisonSchedules } from '../../Async/ReferencesAsync';
import { FormikStyledSelectAsync } from '../../Components/FormikFields/FormikStyledSelectAsync';
import { ListBulkAction } from '../../Contracts/MedicationListModels';
import { Reference, referenceToKey, referenceToString } from '../../Shared/SharedModels';
import styles from './MedicationListSliceStep.module.scss';

export type SliceStepState = {
    bulkAction: ListBulkAction;
    atcCodes: Reference[];
    schedules: Reference[];
    medicinalProducts: Reference[];
};

export const MedicationListSliceStep = (props: { onContinue(): void }) => {
    const form = useFormikContext<SliceStepState>();

    return (
        <>
            <div className={styles.searchInput}>
                <FormikStyledSelectAsync<Reference>
                    isClearable
                    itemToMenuKey={referenceToKey}
                    itemToString={referenceToString}
                    maxResults={5}
                    label='ATC code'
                    isMulti
                    name='atcCodes'
                    testId='atc-code-search'
                    fetch={searchAtcCodes}
                    emptyValue={[]}
                    onChange={() => {
                        form.setFieldError('atcCodes', '');
                    }}
                />
            </div>
            <div className={styles.searchInput}>
                <FormikStyledSelectAsync<Reference>
                    isClearable
                    itemToMenuKey={referenceToKey}
                    itemToString={referenceToString}
                    maxResults={5}
                    label='Schedules'
                    isMulti
                    name='schedules'
                    testId='poison-schedule-search'
                    fetch={searchPoisonSchedules}
                    emptyValue={[]}
                    onChange={() => {
                        form.setFieldError('schedules', '');
                    }}
                />
            </div>
            <div className={styles.searchInput}>
                <FormikStyledSelectAsync<Reference>
                    isClearable
                    itemToMenuKey={referenceToKey}
                    itemToString={referenceToString}
                    maxResults={5}
                    label='Generic product'
                    isMulti
                    name='medicinalProducts'
                    testId='medicinal-products-search'
                    fetch={searchMedicinalProducts}
                    emptyValue={[]}
                    onChange={() => {
                        form.setFieldError('medicinalProducts', '');
                    }}
                />
            </div>
        </>
    );
};
